/** Explicit chart colors mirroring the CSS tokens (SVG attributes can't resolve CSS variables reliably). */
export const chartTheme = (isDark = false) =>
  isDark
    ? {
        primary: "hsl(203 88% 62%)",
        primarySoft: "hsl(203 88% 62%)",
        cyan: "hsl(198 85% 70%)",
        teal: "hsl(172 55% 52%)",
        copper: "hsl(32 85% 62%)",
        rose: "hsl(350 70% 62%)",
        amber: "hsl(38 90% 60%)",
        sky: "hsl(199 89% 60%)",
        grid: "hsl(206 30% 18%)",
        tick: "hsl(205 20% 62%)",
        prev: "hsl(205 20% 70%)",
        faint: "hsl(206 18% 34%)",
        cursor: "hsl(204 40% 95%)",
        live: "hsl(198 88% 77%)",
      }
    : {
        primary: "hsl(208 91% 36%)",
        primarySoft: "hsl(208 91% 36%)",
        cyan: "hsl(198 82% 46%)",
        teal: "hsl(172 58% 34%)",
        copper: "hsl(30 88% 48%)",
        rose: "hsl(350 72% 52%)",
        amber: "hsl(38 92% 50%)",
        sky: "hsl(199 89% 48%)",
        grid: "hsl(210 26% 89%)",
        tick: "hsl(207 16% 46%)",
        prev: "hsl(207 16% 50%)",
        faint: "hsl(210 14% 76%)",
        cursor: "hsl(205 68% 13%)",
        live: "hsl(198 82% 46%)",
      };

export const axisTick = (t) => ({ fontSize: 12, fill: t.tick, fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif", fontVariantNumeric: "tabular-nums" });

/** Pulsing "now" marker for the last data point. */
export const LiveDot = ({ cx, cy, color }) => {
  if (cx === undefined || cy === undefined) return null;
  return (
    <g>
      <circle cx={cx} cy={cy} r="5" fill={color} opacity="0.35" className="svg-pulse" />
      <circle cx={cx} cy={cy} r="3.5" fill={color} stroke="white" strokeWidth="1.5" />
    </g>
  );
};
